import React from 'react';
import clsx from 'clsx';

import styles from './FilterSetting.module.scss';
import Badge from './Badge';
import { BadgeStyles, BadgeSizes } from './Badge';

export default function FilterSetting({
	className,
	text,
	icon,
	number,
	onClick,
	checked,
	disabled
}) {
	return (
		<div
			className={clsx(styles.filter, className && className)}
			onClick={!disabled ? onClick : null}
		>
			{icon}
			<strong>{text}</strong>

			{number ? (
				<Badge
					text={number}
					size={BadgeSizes.SMALL}
					variant={BadgeStyles.PRIMARY}
				/>
			) : null}

			<div className={styles.customCheckboxContainer}>
				<span
					className={clsx(
						styles.customCheckbox,
						checked && styles.checked,
						disabled && styles.disabled
					)}
				>
					<span className={styles.checkmark}></span>
				</span>
			</div>
		</div>
	);
}
